import TeamsWithSubstitueLineUp from '../lib/TeamsWithSubstitueLineUp.js'

class LineUp extends TeamsWithSubstitueLineUp {

	constructor(props) {
			super(props);
	}

	getName() {
		return "Cricket";
	}

}
export default LineUp;
